<div class="data-table-wrapper">
  <div class="data-table-toolbar" [class.hidden]="!filterableColumns.length && !actionLabel">
    <div class="toolbar-left">
      @if (filterableColumns.length) {
        <button
          mat-button
          [class.active]="filterPanelOpen"
          (click)="toggleFilterPanel()"
          class="filter-toggle-btn"
          >
          <mat-icon fontSet="material-icons">filter_list</mat-icon>
          <span>Filtros</span>
          @if (activeFilterCount > 0) {
            <span class="filter-count">{{ activeFilterCount }}</span>
          }
        </button>
      }
    </div>
    <div class="toolbar-right">
      @if (actionLabel) {
        <button
          mat-button
          [class.active]="actionPanelOpen"
          (click)="toggleActionPanel()"
          class="filter-toggle-btn"
          >
          @if (actionIcon) {
            <mat-icon fontSet="material-icons">{{ actionIcon }}</mat-icon>
          }
          <span>{{ actionLabel }}</span>
        </button>
      }
    </div>
  </div>

  <!-- Projected action panel (e.g. "Limpar dados"): always in the DOM so ng-content
       projection is unconditional; visibility via [hidden]. Same look as the filter panel. -->
  <div class="filter-panel action-panel" [hidden]="!actionPanelOpen || !actionLabel">
    <ng-content select="[data-table-actions]"></ng-content>
  </div>

  @if (filterPanelOpen && filterableColumns.length) {
    <div class="filter-panel">
      <form [formGroup]="filterForm" class="filter-form">
        <div class="filter-row">
          <div class="filter-fields">
            @for (col of filterableColumns; track col) {
              @if (col.filterType === 'select') {
                <mat-form-field appearance="outline" class="filter-field"
                  [class.filter-field-wide]="col.filterMultiple"
                  [matTooltip]="col.filterDisabled ? (col.filterDisabledTooltip || '') : ''"
                  matTooltipPosition="above">
                  <mat-label>{{ col.label }}</mat-label>
                  <mat-select
                    [formControlName]="col.key"
                    [multiple]="!!col.filterMultiple"
                    [disabled]="!!col.filterDisabled"
                    (selectionChange)="onFilterApply()"
                    (openedChange)="onSelectPanelToggle(col.key, $event)"
                    panelClass="searchable-select-panel">
                    @if (col.filterSearchable) {
                      <div class="select-search-box" (click)="$event.stopPropagation()">
                        <mat-icon fontSet="material-icons">search</mat-icon>
                        <input
                          class="select-search-input"
                          placeholder="Pesquisar..."
                          [value]="selectSearchTerms[col.key] || ''"
                          (input)="onSelectSearch(col.key, $any($event.target).value)"
                          (keydown)="$event.stopPropagation()"
                          />
                      </div>
                    }
                    @if (!col.filterMultiple) {
                      <mat-option value="">Todos</mat-option>
                    }
                    @for (opt of getFilteredOptions(col); track opt) {
                      <mat-option [value]="opt">{{ opt }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              } @else if (col.type === 'boolean') {
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-label>{{ col.label }}</mat-label>
                  <mat-select [formControlName]="col.key">
                    <mat-option value="">Todos</mat-option>
                    <mat-option [value]="true">Sim</mat-option>
                    <mat-option [value]="false">Não</mat-option>
                  </mat-select>
                </mat-form-field>
              } @else {
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-label>{{ col.label }}</mat-label>
                  @if (!col.type || col.type === 'text') {
                    <input
                      matInput
                      [formControlName]="col.key"
                      type="text"
                      />
                  }
                  @if (col.type === 'number') {
                    <input
                      matInput
                      [formControlName]="col.key"
                      type="number"
                      />
                  }
                </mat-form-field>
              }
            }
          </div>
          <div class="filter-actions">
            <button mat-flat-button color="primary" (click)="onFilterApply()">Aplicar</button>
            <button mat-button (click)="onFilterClear()">Limpar</button>
          </div>
        </div>
      </form>
    </div>
  }

  <div class="table-container">
    @if (loading) {
      <div class="table-loading">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else {
      <table
        mat-table
        [dataSource]="items"
        class="data-table"
        >
        @if (selectable) {
          <ng-container [matColumnDef]="rowSelectColumn">
            <th mat-header-cell *matHeaderCellDef class="select-cell">
              <mat-checkbox
                [checked]="allPageSelected"
                [indeterminate]="somePageSelected"
                (change)="toggleAllPage()"
              ></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" class="select-cell">
              <mat-checkbox
                [checked]="isRowSelected(row)"
                (change)="toggleRow(row)"
              ></mat-checkbox>
            </td>
          </ng-container>
        }
        @for (col of columns; track col) {
          <ng-container [matColumnDef]="col.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="sortable"
              (click)="onSort(col)"
              [style.text-align]="col.align || 'left'"
              >
              <span class="header-label">{{ col.label }}</span>
              @if (isSortActive(col)) {
                <mat-icon class="sort-icon" fontSet="material-icons">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              }
            </th>
            <td mat-cell *matCellDef="let row" [style.text-align]="col.align || 'left'">
              @if (!editable || !col.editable || !isEditing(row)) {
                @if (col.display === 'badge') {
                  @if (getValue(row, col)) {
                    <span class="cell-badge" [ngClass]="col.badgeClass || ''">{{ getValue(row, col) }}</span>
                  }
                } @else if (col.display === 'boolean') {
                  <mat-icon fontSet="material-icons" [class]="getValue(row, col) ? 'bool-icon bool-true' : 'bool-icon bool-false'">
                    {{ getValue(row, col) ? 'check_circle' : 'cancel' }}
                  </mat-icon>
                } @else {
                  {{ getDisplayValue(row, col) }}
                }
              }
              @if (editable && col.editable && isEditing(row)) {
                @if (!col.type || col.type === 'text') {
                  <input
                    type="text"
                    [value]="getDraft(col)"
                    (input)="setDraft(col, $any($event.target).value)"
                    />
                }
                @if (col.type === 'number') {
                  <input
                    type="number"
                    [value]="getDraft(col)"
                    [attr.min]="getEditMin(col)"
                    [attr.max]="getEditMax(col)"
                    [attr.step]="col.displayFormat === 'percent' ? 1 : (col.max !== undefined && col.max <= 1 ? '0.01' : null)"
                    [class.input-error]="isDraftInvalid(col)"
                    (input)="setDraft(col, +$any($event.target).value)"
                    />
                  @if (isDraftInvalid(col)) {
                    <span class="field-error">Valor entre {{ getEditMin(col) }}{{ col.displayFormat === 'percent' ? '%' : '' }} e {{ getEditMax(col) }}{{ col.displayFormat === 'percent' ? '%' : '' }}</span>
                  }
                }
                @if (col.type === 'boolean') {
                  <mat-slide-toggle
                    [checked]="!!getDraft(col)"
                    (change)="setDraft(col, $event.checked)"
                  ></mat-slide-toggle>
                }
              }
            </td>
          </ng-container>
        }
        @if (editable) {
          <ng-container [matColumnDef]="rowActionsColumn">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              @if (!isEditing(row)) {
                <button
                  mat-icon-button
                  (click)="startEdit(row)"
                  matTooltip="Editar"
                  aria-label="Editar"
                  >
                  <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
                </button>
              }
              @if (isEditing(row)) {
                <button
                  mat-icon-button
                  (click)="saveEdit(row)"
                  [disabled]="hasDraftErrors()"
                  matTooltip="Guardar"
                  aria-label="Guardar"
                  >
                  <mat-icon fontSet="material-symbols-outlined">save</mat-icon>
                </button>
                <button
                  mat-icon-button
                  (click)="cancelEdit()"
                  matTooltip="Cancelar"
                  aria-label="Cancelar"
                  >
                  <mat-icon fontSet="material-icons">close</mat-icon>
                </button>
              }
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            Sem dados.
          </td>
        </tr>
      </table>
    }
  </div>

  @if (!loading && total > 0) {
    <mat-paginator
      [length]="total"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPage($event)"
      showFirstLastButtons
    ></mat-paginator>
  }
</div>
